export default {"src":"/_next/static/media/shopify.dbbf5b1c.svg","height":101,"width":89,"blurWidth":0,"blurHeight":0};